// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { xdcTestnet as _xdcTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the xdcTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 51
 * Chain Name: Apothem Network
 * Default Block Explorer: https://apothem.blocksscan.io
 * Default RPC URL: https://erpc.apothem.network
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { xdcTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: xdcTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const xdcTestnet = createCommon({
	..._xdcTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
